import React from "react"
import { useTranslation } from "react-i18next"

import { NumberInput } from "shared/ui/input/number/NumberInput"

interface NumberInputRootProps {
  loading?: boolean
  readonly?: boolean
}

const renderReadonlyValue = (value: string | number | null) => {
  return value || "-"
}

export const ProductPositionQuantityInput = React.memo(
  (props: Partial<NumberInputRootProps>) => {
    const { t } = useTranslation()

    return (
      <NumberInput.Root
        name="productPosition.quantity"
        label={t("General.Quantity")}
        data-testid="product-position-form__quantity"
        step={1}
        min={1}
        format={{ maximumFractionDigits: 0, minimumFractionDigits: 0 }}
        {...props}
      >
        <NumberInput.Label />

        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input data-testid="product-position-form__quantity__input" />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>

        <NumberInput.Readonly render={renderReadonlyValue} />
        <NumberInput.ErrorMessage />
        <NumberInput.InfoMessage />
      </NumberInput.Root>
    )
  }
)
